import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  inputClasses,
  inputLabelClasses,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import Home from "../home/Home";
import FundRqst_service from "../../Services/FundRqst_service";
import Snackbar from "../Snacbar";
import { getUserId } from "../Utils/Common";
import FileSaver from "file-saver";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router";
import { ToggleButton } from "@mui/material";

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
  },
});
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item1 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item2 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "right",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: "rgb(61, 195, 177)",
    padding: theme.spacing(0.5),
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
}));

function FundRefund() {
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [status, setstatus] = useState("");
  const [fundstatusdrp, setfundstatusdrp] = useState([]);
  const [Vendordrp, setVendordrp] = useState([]);
  const [PaymentModedrp, setPaymentModedrp] = useState([]);
  // BE NO specific
  const [BeNoHidden, setBeNoHidden] = useState(true);
  const [BeNoSearchHidden, setBeNoSearchHidden] = useState(true);
  const [beNoValue, setBeNoValue] = useState("");
  const [searchPros, setsearchPros] = useState(false);

  const [Refundfundvalues, setRefundfundvalues] = useState({
    cmid: "",
    purpose_pmtid: "",
    purpose_reqpurid: "",
    purposeSummary_id: "",

    Reqamt: "",
    fundstatus: "",
    jobNo: "",
    vendorType: "",
    refundAmt: "",
    pymntMode: "",
    refundRmks: "",
  });
  ///Handle Change=>>
  const RefundFundStatusHandleChange = (e) => {
    const value = e.target.value;

    // reset existing data
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setRefundDetails([]);
    setRefundDetails2([]);
    setRefundDetails3([]);
    setRefundDetails4([]);
    setRefundDetails5([]);

    setRefundfundvalues({
      ...Refundfundvalues,
      fundstatus: value,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      Reqamt: "",
      refundAmt: "",
      refundRmks: "",
      jobNo: "",
      vendorType: "",
    });

    // hide BE NO controls by default
    setBeNoHidden(true);
    setBeNoSearchHidden(true);

    // ✅ BE NO case
    if (value === "BE NO") {
      setBeNoHidden(false);
      setBeNoSearchHidden(false);
      SetVendorHidden(true);
      SetJobHidden(true);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(true);
      return; // stop further logic
    }

    // Existing status logic
    if (value === "JOB") setstatus(1);
    else if (value === "VENDOR") setstatus(2);
    else if (value === "MISCELLANEOUS") setstatus(3);
    else if (value === "CLIENT") setstatus(4);

    let consignmentNumber = "-1";
    if (value === "JOB") {
      consignmentNumber = Refundfundvalues.jobNo || "-1";
    } else {
      consignmentNumber = Refundfundvalues.vendorType || "-1";
    }

    const details = { consignmentNumber, status: "7", requestStatus: value };

    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setRefundDetails(res.data);
      setFilteredDetails(res.data);
    });

    FundRqst_service.getPaymentJobNo(details).then((res) => {
      setRefundDetails4(res.data);
      setFilteredDetails2(res.data);
    });

    FundRqst_service.getBillPaymentType().then((res) =>
      setPaymentModedrp(res.data)
    );

    if (value === "JOB") {
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);
    } else if (["VENDOR", "MISCELLANEOUS", "CLIENT"].includes(value)) {
      FundRqst_service.getVendorType(value).then((res) =>
        setVendordrp(res.data)
      );
      SetVendorHidden(false);
      SetJobHidden(true);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(true);
    } else if (value === "") {
      SetVendorHidden(true);
      SetJobHidden(true);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(true);
    }
  };

  const handleBeNoSearch = async () => {
    const beNo = beNoValue && beNoValue.trim();
    if (!beNo) {
      setMessage("Please enter BE No before searching!");
      setseverit("warning");
      setOpen(true);
      return;
    }

    setsearchPros(true);

    try {
      // 1️⃣ Fetch BE NO-level data
      const beNoPayload = {
        consignmentNumber: beNo,
        status: "7",
        requestStatus: "BE NO",
      };
      const [nonJobRes, jobRes] = await Promise.all([
        FundRqst_service.getPaymentNonJobNo(beNoPayload),
        FundRqst_service.getPaymentJobNo(beNoPayload),
      ]);

      const beNoData = [...(nonJobRes?.data || []), ...(jobRes?.data || [])];
      const consignmentNumbers = [
        ...new Set(beNoData.map((d) => d.consignmentNumber).filter(Boolean)),
      ];

      if (consignmentNumbers.length === 0) {
        setMessage("No consignment numbers found for this BE No!");
        setseverit("info");
        setOpen(true);
        setsearchPros(false);
        return;
      }

      // 2️⃣ Fetch JOB data for each consignment number
      const jobRequests = consignmentNumbers.map((cno) => {
        const jobPayload = {
          consignmentNumber: cno,
          status: "7",
          requestStatus: "JOB",
        };
        return Promise.all([
          FundRqst_service.getPaymentNonJobNo(jobPayload),
          FundRqst_service.getPaymentJobNo(jobPayload),
        ]);
      });

      const responses = await Promise.all(jobRequests);
      const allNonJob = [];
      const allJob = [];

      responses.forEach(([nonJob, job]) => {
        if (nonJob?.data) allNonJob.push(...nonJob.data);
        if (job?.data) allJob.push(...job.data);
      });

      // 3️⃣ Update Refund-level tables
      setRefundDetails(allNonJob);
      setFilteredDetails(allNonJob);
      setRefundDetails4(allJob);
      setFilteredDetails2(allJob);

      setBeNoHidden(true);
      setBeNoSearchHidden(true);
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);
      // ✅ Update Fund Status dropdown value
      setRefundfundvalues((prev) => ({
        ...prev,
        fundstatus: "JOB",
      }));

      // ✅ Optional success feedback
      setMessage("BE No search completed — switched to JOB mode");
      setseverit("success");
      setOpen(true);
    } catch (err) {
      setMessage(err.message || "Error fetching BE NO details");
      setseverit("error");
      setOpen(true);
    } finally {
      setsearchPros(false);
    }
  };

  const Refund_jobNoHandleChange = (e) => {
    setRefundfundvalues({
      ...Refundfundvalues,
      jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const Refund_vendortypHandleChange = (e) => {
    setRefundfundvalues({
      ...Refundfundvalues,
      vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
    let details = {
      consignmentNumber: e.target.value,
      status: "7",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setRefundDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: e.target.value,
      status: "7",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setRefundDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };
  const Refund_amtHandleChange = (e) => {
    setRefundfundvalues({
      ...Refundfundvalues,
      refundAmt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const Refund_paymntmdHandleChange = (e) => {
    setRefundfundvalues({
      ...Refundfundvalues,
      pymntMode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const Refund_RmksHandleChange = (e) => {
    setRefundfundvalues({
      ...Refundfundvalues,
      refundRmks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const FundStsName = () => {
    if (status === 1) {
      return "Job No";
    } else if (status === 2) {
      return "VENDOR";
    } else if (status === 3) {
      return "MISCELLANEOUS";
    } else if (status === 4) {
      return "CLIENT";
    }
  };
  //keydown
  const jobkeydown = (e) => {
    if (e.key === "Enter") {
      SearchOnclick();
    }
  };
  const refundAmtkeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("paymntid").focus();
    }
  };
  const paymentMdkeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("rmks").focus();
    }
  };
  ///hidden
  const [designHidden, setdesignHidden] = useState(true);
  const [tablehidden, settablehidden] = useState(true);
  const [VendorHidden, SetVendorHidden] = useState(true);
  const [JobHidden, SetJobHidden] = useState(false);
  const [searchbtnhidden, setsearchbtnhidden] = useState(true);

  const [RefundDetails, setRefundDetails] = useState([]);
  const [RefundDetails2, setRefundDetails2] = useState([]);
  const [RefundDetails3, setRefundDetails3] = useState([]);
  const [RefundDetails4, setRefundDetails4] = useState([]);
  const [RefundDetails5, setRefundDetails5] = useState([]);
  const [paymentcopydetails, setpaymentcopydetails] = useState([]);
  //
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [FilteredDetails2, setFilteredDetails2] = useState([]);

  const [RefundDis, setRefundDis] = useState(true);
  const [UpdateDis, setUpdateDis] = useState(true);
  const [NonRefundDis, setNonRefundDis] = useState(true);
  const [DownReqDis, setDownReqDis] = useState(true);
  ///processing
  const [refundProcs, setrefundProcs] = useState(false);
  const [UpdateProcs, setUpdateProcs] = useState(false);
  const [nonrefundProcs, setnonrefundProcs] = useState(false);
  const [dwnldRqstCopyProcs, setdwnldRqstCopyProcs] = useState(false);
  const [RefreshProcs, setRefreshProcs] = useState(false);
  ////clear all operations====>
  const resetalloperation = () => {
    setRefundfundvalues({
      ...Refundfundvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      Reqamt: "",
      refundAmt: "",
      refundRmks: "",
      jobNo: "",
    });
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setRefundDetails([]);
    setRefundDetails2([]);
    setRefundDetails3([]);
    setRefundDetails4([]);
    setRefundDetails5([]);
    setrefundProcs(false);
    setUpdateProcs(false);
    setnonrefundProcs(false);
    setdwnldRqstCopyProcs(false);
    setRefreshProcs(false);
    setRefundDis(true);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(true);
  };
  // validation.........
  const validationprocess = () => {
    console.log("in");
    if (Refundfundvalues.refundAmt !== "") {
      console.log("refund amt in");
      if (Refundfundvalues.pymntMode !== "") {
        console.log("pay md in");
        return true;
      } else {
        setMessage("Please Select Payment Mode");
        setseverit("warning");
        setOpen(true);
        document.getElementById("paymntid").focus();
      }
    } else {
      setMessage("Please Enter Payment Request Amount");
      setseverit("warning");
      setOpen(true);
      document.getElementById("refundid").focus();
    }
    return false;
  };
  ////search Btn====>
  const SearchOnclick = () => {
    setRefundDis(true);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(true);
    setRefundfundvalues({
      ...Refundfundvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    setRefundDetails2([]);
    setRefundDetails3([]);
    Getpaymentjob_nonjob_no();
  };
  ///
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState([]);
  /////
  const getnonpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setRefundDetails2([]);
    setRefundDetails5([]);
    setRefundDis(true);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(true);
    setRefundfundvalues({
      ...Refundfundvalues,
      cmid: trns.cmId,
      Reqamt: "",
      refundAmt: "",
      pymntMode: "",
      refundRmks: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    setRefundDetails3([]);

    let details = {
      cmId: trns.cmId,
      status: "13",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setRefundDetails2(res.data);
    });
    let details2 = {
      paymentId: trns.cmId,
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setRefundDetails5(res.data);
    });
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  ///
  const nonverifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setRefundDis(false);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(false);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1);

    let details = { cmId: trns.cmId, reqPurpose: trns.reqPurpose, status: "1" };
    FundRqst_service.getPaymentCopy(details).then((res) => {
      setpaymentcopydetails(res.data);
    });
  };
  const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ///
  const verifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setRefundDis(true);
    setUpdateDis(false);
    setNonRefundDis(false);
    setDownReqDis(false);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2);

    let details = {
      cmId: Refundfundvalues.cmid,
      reqPurpose: trns.reqPurpose,
      status: "2",
    };
    FundRqst_service.getPaymentCopy(details).then((res) => {
      setpaymentcopydetails(res.data);
    });
  };
  const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ///
  const getpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setRefundDetails3([]);
    setRefundDetails5([]);
    setRefundDis(true);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(true);
    setRefundfundvalues({
      ...Refundfundvalues,
      cmid: Refundfundvalues.cmid,
      Reqamt: "",
      refundAmt: "",
      pymntMode: "",
      refundRmks: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    setRefundDetails2([]);

    let details = {
      cmId: trns.cmId,
      status: "14",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setRefundDetails3(res.data);
    });
    let details2 = {
      paymentId: trns.cmId,
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setRefundDetails5(res.data);
    });
  };
  const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
  ///get
  const Getpaymentjob_nonjob_no = () => {
    var consignmentNumber = "";
    if (Refundfundvalues.fundstatus === "JOB") {
      if (Refundfundvalues.jobNo === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = Refundfundvalues.jobNo;
      }
    } else if (Refundfundvalues.fundstatus !== "JOB") {
      if (Refundfundvalues.vendorType === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = Refundfundvalues.vendorType;
      }
    }
    let details = {
      consignmentNumber: consignmentNumber,
      status: "7",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setRefundDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: consignmentNumber,
      status: "7",
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setRefundDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };

  ///getFirtLvlvrfyAssign====>
  const getpaymentdetailsAssign = (payid, reqid, val) => {
    let details = { paymentId: payid };
    FundRqst_service.getPaymentDetails(details)
      .then((res) => {
        const data = res.data;
        const details = data.map((trns) => trns);
        var txt_amount,
          refundMode = "";
        if (val === 1) {
          txt_amount = details[0].reqAmount;
        } else {
          txt_amount = details[0].refundAmt;
        }
        if (
          details[0].allocatedMode === null ||
          details[0].allocatedMode === "" ||
          !details[0].allocatedMode
        ) {
          refundMode = "";
        } else {
          refundMode = details[0].allocatedMode;
        }
        setRefundfundvalues({
          ...Refundfundvalues,
          refundAmt: txt_amount,
          Reqamt: details[0].reqAmount,
          refundRmks: details[0].refundRemarks,
          pymntMode: refundMode,
          purpose_pmtid: payid,
          purpose_reqpurid: reqid,
        });
      })
      .catch((error) => {
        setMessage(error.message);
        setseverit("error");
        setOpen(true);
      });
  };
  ///button operation==>

  const Refund_update_operations = () => {
    if (validationprocess() === true) {
      let details = {
        cmId: Refundfundvalues.purpose_pmtid,
        reqAmount: null,
        reqPurpose: null,
        reqPaidTo: null,
        reqDate: null,
        reqBy: null,
        approvalAmunt: Refundfundvalues.refundAmt,
        approvalDate: null,
        approvalBy: getUserId(),
        firstLevelAmount: null,
        firstLevelDate: null,
        firstVeryBy: null,
        secondLevelAmount: null,
        secondLevelDate: null,
        secondVeryBy: null,
        allocatedAmount: Refundfundvalues.Release_amt,
        allocatedMode: Refundfundvalues.pymntMode,
        allocatedVoucherNo: null,
        allocatedVoucherType: null,
        allocatedVocherCopy: null,
        allocatedPrintedBy: null,
        allocatedDate: null,
        allocatedBy: getUserId(),
        status: "7",
        remarks: Refundfundvalues.refundRmks,
        referenceNo: null,
        bankName: null,
        accountNo: null,
        ifsc: null,
        benName: null,
        gstinPayee: null,
        requestStatus: Refundfundvalues.fundstatus,
        refundStatus: null,
      };
      FundRqst_service.updatePaymentDetails(details)
        .then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Refund Successfully");
            setseverit("success");
            setOpen(true);
            resetalloperation();
            Getpaymentjob_nonjob_no();
          } else {
            setMessage("Refund Failed " + message.toString());
            setseverit("error");
            setOpen(true);
          }
        })
        .catch((error) => {
          setMessage("Refund Failed " + error.message);
          setseverit("error");
          setOpen(true);
        });
    }
  };
  const RefundOnclick = () => {
    setrefundProcs(true);
    Refund_update_operations();
    setrefundProcs(false);
  };
  const updateOnclick = () => {
    setUpdateProcs(true);
    Refund_update_operations();
    setUpdateProcs(false);
  };
  const NonRefundOnclick = () => {
    setnonrefundProcs(true);
    let details = {
      cmId: Refundfundvalues.cmid,
      paymentId: Refundfundvalues.purpose_pmtid,
      status: "7",
      createdBy: getUserId(),
      requestStatus: Refundfundvalues.fundstatus,
    };
    FundRqst_service.updatePaymentStatus(details)
      .then((res) => {
        const message = res.data.message;
        if (message.toString() === "SUCCESS") {
          setMessage("Non Refund Successfully");
          setseverit("success");
          setOpen(true);
          resetalloperation();
          Getpaymentjob_nonjob_no();
        } else {
          setMessage("Non-Refund Failed ,Warning ..!!" + message.toString());
          setseverit("error");
          setOpen(true);
          document.getElementById("refundid").focus();
        }
      })
      .catch((error) => {
        setMessage("Non-Refund Failed " + error.message);
        setseverit("error");
        setOpen(true);
      });
    setnonrefundProcs(false);
  };
  const saveimage = () => {
    setdwnldRqstCopyProcs(true);
    const lastresult = paymentcopydetails.map((item) => item);
    // FileSaver.saveAs(lastresult[0].docImage, Refundfundvalues.cmid + "-" + Refundfundvalues.purpose_reqpurid + ".pdf");
    const filedata = lastresult[0].toString();
    const formates = filedata.split("/9j/4");
    //    console.log('ggg '+JSON.stringify(formates))
    if (formates[0] === "") {
      FileSaver.saveAs(
        `data:image/jpg;base64,${lastresult[0].toString()}`,
        Refundfundvalues.cmid + "-" + Refundfundvalues.purpose_reqpurid + ".jpg"
      );
    } else {
      const Pngformates = filedata.split("iVBORw0KGg");
      if (Pngformates[0] === "") {
        FileSaver.saveAs(
          `data:image/jpg;base64,${lastresult[0].toString()}`,
          Refundfundvalues.cmid +
            "-" +
            Refundfundvalues.purpose_reqpurid +
            ".jpg"
        );
      } else {
        FileSaver.saveAs(
          `data:application/pdf;base64,${lastresult[0].toString()}`,
          Refundfundvalues.cmid +
            "-" +
            Refundfundvalues.purpose_reqpurid +
            ".pdf"
        );
      }
    }
    setdwnldRqstCopyProcs(false);
  };

  const RefreshOnclick = () => {
    setRefreshProcs(true);
    setrefundProcs(false);
    setUpdateProcs(false);
    setnonrefundProcs(false);
    setdwnldRqstCopyProcs(false);
    Getpaymentjob_nonjob_no();
    setRefundfundvalues({
      ...Refundfundvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      Reqamt: "",
      refundAmt: "",
      refundRmks: "",
      jobNo: "",
      fundstatus: "JOB",
    });
    setRefundDetails([]);
    setRefundDetails2([]);
    setRefundDetails3([]);
    setRefundDetails4([]);
    document.getElementById("fundid").focus();
    setRefundDis(true);
    setUpdateDis(true);
    setNonRefundDis(true);
    setDownReqDis(true);
    setRefreshProcs(false);
  };

  ////getfundstatues=======>
  const FundStatusDropdown = async () => {
    FundRqst_service.getFundStatus().then((res) => {
      setfundstatusdrp(res.data);
    });
  };
  ///
  const fundSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fundOnchange(e.target.value);
        }}
      />
    );
  };
  const fundOnchange = (searchedVal) => {
    const filteredvalue = RefundDetails.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails(RefundDetails);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const fundSrch2 = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fund2Onchange(e.target.value);
        }}
      />
    );
  };
  const fund2Onchange = (searchedVal) => {
    const filteredvalue = RefundDetails4.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails2(RefundDetails4);
    } else {
      setFilteredDetails2(filteredvalue);
    }
  };
  useEffect(() => {
    FundStatusDropdown();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate("/fundaudit");
  };
  // const ForwordBotton =()=>{
  //     if (getUserTypeSession() === 'Accounts_admin') {
  //   navigate('/jobAudit');
  //     }
  // }
  return (
    <div>
      <Home />
      <Snackbar
        open={open}
        message={message}
        severity={severit}
        onClose={handleClose}
      />
      <div
        style={{
          paddingLeft: "80px",
          transition: "1s",
          transitionDelay: "revert-layer",
        }}
      >
        <Row>
          <Col xs={1}>
            <ToggleButton
              onClick={BackBotton}
              className="headerstyleStrt"
              size="small"
            >
              <ArrowBackIosIcon
                fontSize="small"
                style={{
                  fontSize: "16px",
                  marginLeft: "5px",
                  color: "red",
                  fontWeight: "bold",
                }}
              />{" "}
            </ToggleButton>
          </Col>
          <Col xs={10}></Col>
          {/* <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton> */}
          {/* </Col> */}
        </Row>
        <Grid2 container>
          <Box style={{ width: "11.5%" }}>
            <Item1>
              {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  marginLeft: "2px",
                  fontFamily: "Times New Roman",
                }}
              >
                Non Refund Job
              </lable>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.map((trns) => {
                      const isItemSelected = isSelected(trns.consignmentNumber);
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getnonpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item1>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  fontFamily: "Times New Roman",
                }}
              >
                Non Refund Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ textAlign: "center", width: "100px" }}
                      >
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {RefundDetails2.map((trns) => {
                      const isItemSelected = isNonReqItemSelected(
                        trns.reqAmount
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.reqAmount}
                          onClick={() => nonverifypurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "37%" }}>
            <Item>
              <div
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "2%",
                  marginBottom: "2%",
                  fontFamily: "Times New Roman",
                }}
              >
                <center>FUND REFUND</center>
              </div>

              <Csscontrol fullWidth size="small" style={{ width: "35%" }}>
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Fund Status
                </InputLabel>
                <Select
                  label="Fund Statusss"
                  id="fundid"
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={RefundFundStatusHandleChange}
                  value={Refundfundvalues.fundstatus}
                >
                  <MenuItem></MenuItem>
                  {fundstatusdrp.map((status) => (
                    <MenuItem value={status.requestStatus}>
                      {status.requestStatus}
                    </MenuItem>
                  ))}
                </Select>
              </Csscontrol>
              {!BeNoHidden && (
                <>
                  <CssTextField
                    size="small"
                    label="BE NO"
                    variant="outlined"
                    sx={{
                      input: {
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "13px",
                      },
                    }}
                    style={{ marginLeft: "2%", width: "35%", marginTop: "1%" }}
                    value={beNoValue}
                    onChange={(e) => setBeNoValue(e.target.value)}
                  />
                  <Button
                    size="small"
                    hidden={BeNoSearchHidden}
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: "1%", marginTop: "1%" }}
                    onClick={handleBeNoSearch}
                  >
                    {searchPros ? "Processing..." : "Search"}
                  </Button>
                </>
              )}

              <CssTextField
                hidden={JobHidden}
                size="small"
                sx={{
                  input: {
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "13px",
                  },
                }}
                style={{ width: "35%", marginLeft: "2%", marginRight: "1%" }}
                label="Job No"
                variant="outlined"
                onChange={Refund_jobNoHandleChange}
                value={Refundfundvalues.jobNo}
                onKeyDown={jobkeydown}
              />

              <Button
                style={{ fontFamily: "Times New Roman" }}
                size="small"
                hidden={searchbtnhidden}
                variant="contained"
                color="primary"
                onClick={SearchOnclick}
              >
                Search
              </Button>

              <Csscontrol
                hidden={VendorHidden}
                fullWidth
                size="small"
                style={{ width: "35%", marginLeft: "2%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Vendor Type
                </InputLabel>
                <Select
                  InputLabelProps={{ shrink: true }}
                  label="Vendor Typeeee"
                  native
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={Refund_vendortypHandleChange}
                  value={Refundfundvalues.vendorType}
                >
                  <option></option>
                  {Vendordrp.map((trns) => (
                    <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                  ))}
                </Select>
              </Csscontrol>

              <div hidden={designHidden}>
                <Row className="mt-4 mb-2">
                  <Col>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      Request Amount :
                    </InputLabel>
                  </Col>
                  <Col
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {Refundfundvalues.Reqamt}
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <CssTextField
                      size="small"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      label="Refund Amount"
                      variant="outlined"
                      id="refundid"
                      style={{ width: "45%" }}
                      required
                      onChange={Refund_amtHandleChange}
                      value={Refundfundvalues.refundAmt}
                      onKeyDown={refundAmtkeydown}
                    />

                    <Csscontrol
                      fullWidth
                      size="small"
                      style={{ width: "45%", marginLeft: "1%" }}
                      required
                      onKeyDown={paymentMdkeydown}
                    >
                      <InputLabel
                        id="demo-select-small"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Mode
                      </InputLabel>
                      <Select
                        label="Payment Modeee"
                        id="paymntid"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                        InputLabelProps={{ shrink: true }}
                        native
                        onChange={Refund_paymntmdHandleChange}
                        value={Refundfundvalues.pymntMode}
                      >
                        <option></option>
                        {PaymentModedrp.map((trns) => (
                          <option value={trns.paymentType}>
                            {trns.paymentType}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      size="small"
                      label="Refund Remarks"
                      variant="outlined"
                      style={{ width: "49%" }}
                      id="rmks"
                      onChange={Refund_RmksHandleChange}
                      value={Refundfundvalues.refundRmks}
                    />
                  </Col>
                </Row>
              </div>
            </Item>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  fontFamily: "Times New Roman",
                }}
              >
                Refund Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {RefundDetails3.map((trns) => {
                      const isItemSelected = isReqItemSelected(trns.reqAmount);
                      return (
                        <TableRow
                          selected={isItemSelected}
                          hover
                          key={trns.reqPurpose}
                          onClick={() => verifypurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "11.5%" }}>
            <Item2>
              <center>
                <lable
                  style={{
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "red",
                    marginRight: "10px",
                    fontFamily: "Times New Roman",
                  }}
                >
                  Refund Job
                </lable>
              </center>
              {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch2()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails2.map((trns) => {
                      const isItemSelected = isReqjobSelected(
                        trns.consignmentNumber
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item2>
          </Box>
        </Grid2>
        <center hidden={designHidden}>
          <div className="mt-2 mb-1 form-inline">
            <Button
              size="small"
              style={{ fontFamily: "Times New Roman" }}
              variant="contained"
              color="primary"
              className="mt-1"
              disabled={RefundDis}
              onClick={RefundOnclick}
            >
              {refundProcs ? "processing..." : "REFUND"}
            </Button>{" "}
            <Button
              size="small"
              style={{ fontFamily: "Times New Roman" }}
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={UpdateDis}
              onClick={updateOnclick}
            >
              {UpdateProcs ? "processing..." : "UPDATE"}
            </Button>{" "}
            <Button
              size="small"
              style={{ fontFamily: "Times New Roman" }}
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={NonRefundDis}
              onClick={NonRefundOnclick}
            >
              {nonrefundProcs ? "processing..." : "NON REFUND"}
            </Button>{" "}
            <Button
              size="small"
              style={{ fontFamily: "Times New Roman" }}
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={DownReqDis}
              onClick={saveimage}
            >
              {dwnldRqstCopyProcs ? "processing..." : "Download Request copy"}
            </Button>{" "}
            <Button
              size="small"
              style={{ fontFamily: "Times New Roman" }}
              variant="contained"
              className="mt-1"
              color="primary"
              onClick={RefreshOnclick}
            >
              {RefreshProcs ? "processing..." : "REFRESH"}
            </Button>
          </div>
        </center>
        <Item hidden={tablehidden}>
          <TableContainer sx={{ maxHeight: 215 }} className="scrollbarPrime">
            <Table stickyHeader className="table table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Sl
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Description
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Request_Date
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2nd_ApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedBY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Release_BY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedBY
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {RefundDetails5.map((trns) => (
                  <TableRow hover key={trns.reqPurpose}>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.serialNumber}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqPurpose}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalAmunt}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.appRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.release_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_amount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_remarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audited_by}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Item>
      </div>
    </div>
  );
}
export default FundRefund;
